import React = require('react');
import * as ReactDOM from "react-dom";
import { Application } from "./App";
import * as $ from "jquery";

function getAccessToken(): string {
    let token = document.location.search.split('t=')[1];
    return token;
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

$.ajaxSetup({
    beforeSend: function (xhr) {
        xhr.setRequestHeader('FWSEC-XSRF-TOKEN', readCookie('FWSEC-XSRF-TOKEN'));
    },
    error: function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.status == 401) {
            console.log("ajaxSetup an error occured");
            var _hostname = window.location.hostname;
            var _currentPage = window.location.href;
            var redirectionToLogin = "";
            redirectionToLogin = "https://" + _hostname + "/login/HandleHPIDRedirect.aspx?destination=firmwaresecurity&returnurl=" + _currentPage;
            window.location.href = redirectionToLogin;
        } else if (jqXHR.status == 302) {
            var _location = jqXHR.getResponseHeader('x-ajax-redirect-location');
            console.log('Redirecting to ' + _location);
            console.log('response text:');
            console.log(jqXHR.responseText);
            window.location.href = _location;
        } else {
            console.log('status: ' + jqXHR.statusText + ' (' + jqXHR.status + ')');
            console.log('response text:');
            console.log(jqXHR.responseText);
            window.location.href = "wwwroot/error.html";
        }
    }
});

ReactDOM.render(
    React.createElement(Application, null),
    document.getElementById('root')
);
